<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon>
        <slot name="title"></slot>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                  limpar();
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="possuiMunicipio">
          <v-col sm="6">
            <combobox-municipio
              @onChange="changeMunicipio"
            ></combobox-municipio>
          </v-col>
        </v-row>
        <v-row v-if="!possuiMunicipio || payload.municipioValor">
          <v-col sm="6">
            <v-select
              id="group-solution-select"
              v-model="payload.grupoSolucao"
              item-text="nome"
              item-value="municipioGrupoSolucaoId"
              :items="groupSolutionList"
              :label="`${
                isAT
                  ? 'Grupo de Iniciativas'
                  : isGov
                  ? 'Grupo de fases'
                  : 'Grupo de Soluções'
              }`"
              :placeholder="`${
                isAT
                  ? 'Grupo de Iniciativas'
                  : isGov
                  ? 'Grupo de fases'
                  : 'Grupo de Soluções'
              }`"
              :return-object="true"
              @change="changeGroupSolution"
            >
              <template slot="no-data">
                Nenhum
                {{
                  isAT
                    ? "Grupo de Iniciativa"
                    : isGov
                    ? "Grupo de Fases"
                    : "Grupo de Solução"
                }}
                retornado
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row v-if="!possuiMunicipio || payload.municipioValor">
          <v-col sm="6">
            <SolutionCombobox
              :itens="solucoes"
              :filter="payload"
              @onChange="change"
              :disabled="!payload.grupoSolucao.municipioGrupoSolucaoId"
            ></SolutionCombobox>
          </v-col>
        </v-row>
        <v-row v-if="!possuiMunicipio || payload.municipioValor">
          <v-col>
            <AppConsultantCombobox :filter="payload"></AppConsultantCombobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              dialog = false;
              limpar();
            }
          "
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="
            !payload.grupoSolucao.municipioGrupoSolucaoId ||
            solucoesOriginais.length == 0
          "
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityGroupSolutionAPI, citySolutionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import { solutionAPI } from "@/modules/solution";
import SolutionCombobox from "@/modules/solution/components/city/Combobox.vue";
import { compare } from "@/helpers/orderByAsc";
import ComboboxMunicipio from "../../../city/components/ComboboxMunicipio.vue";
import { AppConsultantCombobox } from "@/modules/user";

export default {
  name: "AppModalImportGroupSolution",
  components: {
    SolutionCombobox,
    ComboboxMunicipio,
    AppConsultantCombobox,
  },
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { municipioGrupoSolucao: {} },
    possuiMunicipio: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        grupoSolucao: {
          solucoes: [],
        },
      },
      solucoesOriginais: [],
      dialog: false,
      groupSolutionList: [],
      solucoes: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isAT", "isGov"]),
  },
  watch: {
    dialog(val) {
      if (val && !this.possuiMunicipio) this.getGroupSolution();
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    change(event) {
      this.solucoesOriginais = event;
    },
    changeMunicipio(e) {
      this.payload.municipioValor = e;
      this.$forceUpdate();

      var filtro = {
        municipioId: e,
      };

      cityGroupSolutionAPI
        .listByCity(filtro)
        .then((resp) => {
          this.groupSolutionList = resp.data
            .sort((a, b) => compare(a, b, "nome"))
            .filter((item) => item.grupoSolucaoId != null);

          this.setLoading(false);
        })
        .catch((e) => {
          this.setLoading(false);
        });
    },
    limpar() {
      this.payload = {};
      this.payload.municipioId = this.$route.params.id;
      this.payload.grupoSolucao = { solucoes: [] };
      this.$forceUpdate();
    },
    onConfirm() {
      this.setLoading(true);
      this.payload.grupoSolucao.usuarioId = this.user.usuarioId;
      citySolutionAPI
        .addByGrupoSolucao({
          ...this.payload.grupoSolucao,
          solucoesOriginais: this.solucoesOriginais,
          usuarioId: this.payload.usuarioId || 1,
        })
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Solução incluída com sucesso");
          this.dialog = false;
          this.limpar();
          this.$emit("onSave");
          this.getGroupSolution();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao incluir grupo solução");
        });
    },
    changeGroupSolution(e) {
      this.setLoading(true);
      solutionAPI
        .getByGrupo(
          this.payload.grupoSolucao.grupoSolucaoId || e.grupoSolucaoId,
          this.$route.params.id || this.payload.municipioValor
        )
        .then((resp) => {
          this.solucoes = resp.data.sort((a, b) => compare(a, b, "nome"));
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
    getGroupSolution() {
      this.setLoading(true);

      var filtro = {
        municipioId: this.$route.params.id,
      };
      cityGroupSolutionAPI
        .listByCity(filtro)
        .then((resp) => {
          this.groupSolutionList = resp.data
            .sort((a, b) => compare(a, b, "nome"))
            .filter((item) => item.grupoSolucaoId != null);

          this.setLoading(false);
        })
        .catch((e) => {
          this.setLoading(false);
        });
    },
  },
};
</script>
